<template>
<div :class="classes">
	<div class="showmore-items__primary" v-if="$slots.primary">
		<slot name="primary"></slot>
	</div>
	<div class="showmore-items__secondary" v-if="$slots.secondary">
		<NavSidebarItem
			v-if="!isExpanded"
			class-name="nav-sidebar__item"
			:is-selected="false"
			@click="toggleExpansion"
		>
			<template v-slot:text>
				{{ $t( "sidebar.ShowmoreItems_showMoreLabel" ) }}
			<font-awesome-icon :icon="['fas', 'angle-double-down']" />
			</template>
		</NavSidebarItem>
		<slot name="secondary" v-if="isExpanded"></slot>
		<NavSidebarItem
			v-if="isExpanded"
			class-name="nav-sidebar__item"
			:is-selected="false"
			@click="toggleExpansion"
		>
			<template v-slot:text>
				{{ $t( "sidebar.ShowmoreItems_showFewerLabel" ) }}
			<font-awesome-icon :icon="['fas', 'angle-double-up']" />
			</template>
		</NavSidebarItem>

	</div>
</div>
</template>

<script>
import NavSidebarItem from "@/components/Sidebar/NavSidebarItem";

export default {
	name: "ShowmoreItems",
	components: {
		NavSidebarItem,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			isExpanded: false,
		};
	},
	computed: {
		classes() {
			return {
				"showmore-items": true,
				[ this.className ]: !!this.className,
			};
		},
	},
	methods: {
		toggleExpansion() {
			this.isExpanded = !this.isExpanded;
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/Sidebar/ShowmoreItems.vue